/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateFragmentCreationMutationRequest, WebAppCreateFragmentCreationMutationResponse } from "../models/WebAppCreateFragmentCreation";

export function getWebAppCreateFragmentCreationUrl() {
  const res = { method: 'POST', url: `/web-app/v1/fragments` as const }
  return res
}

/**
 * @summary Create a fragment
 * {@link /web-app/v1/fragments}
 */
export async function webAppCreateFragmentCreation(data: WebAppCreateFragmentCreationMutationRequest, config: Partial<RequestConfig<WebAppCreateFragmentCreationMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<WebAppCreateFragmentCreationMutationResponse, ResponseErrorConfig<Error>, WebAppCreateFragmentCreationMutationRequest>({ method : "POST", url : getWebAppCreateFragmentCreationUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}